import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";

const Philosophy = () => {
  return (
    <Box margin={{ xs: "35% 0%", sm: "10% 0% 10% 0%" }} data-aos={"fade-down"}>
      <Typography
        variant="h3"
        fontWeight={700}
        textAlign={"left"}
        paddingBottom={{ xs: "4%", sm: "2%" }}
        color={"#39484E"}
      >
        Philanthropic Philosophy
      </Typography>
      <Box width={{ xs: "100%", sm: "100% " }}>
        <Typography
          variant="h6"
          fontWeight={400}
          textAlign={"left"}
          paddingBottom={{ xs: "4%", sm: "2% " }}
        >
          The AIR Fund's commitment to transformative change is guided by four
          foundational principles.
        </Typography>
      </Box>

      <Box>
        <Grid container spacing={1} margin={{ xs: " 0%", sm: "0% 0% 4% 0%" }}>
          <Grid item xs={12} sm={6} md={3} margin={{ xs: "5% 0%", sm: "0%" }}>
            <Box
              height={"100%"}
              padding={{ xs: "4% 4%", sm: "8% 8% 4% 8%" }}
              margin={{ xs: "2% 0%", sm: "2% 0%" }}
              display={"flex"}
              component={Card}
              flexDirection={"column"}
              borderRadius={"20px"}
              width={{ xs: "100%", sm: "100%" }}
            >
              <Typography
                variant={"h5"}
                fontWeight={700}
                paddingTop={"6%"}
                color={"#39484E"}
              >
                Taking Big Bets on Scalable Solutions
              </Typography>
              <Typography variant={"body1"} paddingTop={"4%"} color={"#000"}>
                AIR Fund invests in high-impact projects with proven models that
                address Africa’s pressing challenges. Scalable solutions like
                community-based climate monitoring and real-time flood detection
                empower local communities, saving lives and reducing
                disaster-related losses. By expanding successful initiatives to
                underserved regions, AIR Fund maximizes their transformative
                potential.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3} margin={{ xs: "5% 0%", sm: "0%" }}>
            <Box
              height={"100%"}
              padding={{ xs: "4% 4%", sm: "8% 8% 4% 8%" }}
              margin={{ xs: "2% 0%", sm: "2% 0%" }}
              display={"flex"}
              component={Card}
              flexDirection={"column"}
              borderRadius={"20px"}
              width={{ xs: "100%", sm: "100%" }}
            >
              <Typography
                variant={"h5"}
                fontWeight={700}
                paddingTop={"6%"}
                color={"#39484E"}
              >
                Taking Early Bets on Emerging Ideas
              </Typography>
              <Typography variant={"body1"} paddingTop={"4%"} color={"#000"}>
                AIR Fund supports early-stage innovations that address last-mile
                delivery gaps. By funding AI-powered urban planning tools, we
                enable communities to actively shape their cities. Our support
                provides local innovators with resources and pilot opportunities
                to demonstrate viability, unlocking larger investments and
                broader impact.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3} margin={{ xs: "5% 0%", sm: "0%" }}>
            <Box
              height={"100%"}
              padding={{ xs: "4% 4%", sm: "8% 8% 4% 8%" }}
              margin={{ xs: "2% 0%", sm: "2% 0%" }}
              display={"flex"}
              component={Card}
              flexDirection={"column"}
              borderRadius={"20px"}
              width={{ xs: "100%", sm: "100%" }}
            >
              <Typography
                variant={"h5"}
                fontWeight={700}
                paddingTop={"6%"}
                color={"#39484E"}
              >
                Prioritizing Inclusion and Equity
              </Typography>
              <Typography variant={"body1"} paddingTop={"4%"} color={"#000"}>
                AIR is committed to equitable funding, ensuring support reaches
                women, youth, people with disabilities, and marginalized
                communities. Our inclusive grant criteria prioritize African-led
                projects that directly benefit diverse groups, embedding equity
                at every stage—from selection to outcome evaluation.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3} margin={{ xs: "5% 0%", sm: "0%" }}>
            <Box
              height={"100%"}
              padding={{ xs: "4% 4%", sm: "8% 8% 4% 8%" }}
              margin={{ xs: "2% 0%", sm: "2% 0%" }}
              display={"flex"}
              component={Card}
              flexDirection={"column"}
              borderRadius={"20px"}
              width={{ xs: "100%", sm: "100%" }}
            >
              <Typography
                variant={"h5"}
                fontWeight={700}
                paddingTop={"6%"}
                color={"#39484E"}
              >
                Promoting African Resilience
              </Typography>
              <Typography variant={"body1"} paddingTop={"4%"} color={"#000"}>
                AIR invests in initiatives that build local capacity, enhance
                governance, and support community-led planning. By empowering
                African talent and decision-making, we foster long-term
                resilience, ensuring sustainability beyond individual projects
                and enabling communities to drive their own progress.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Philosophy;
